import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TripHistoryChangeComponent } from './trip-history-change.component';
import {ReservationService} from '../reservations.service';
import {FormsModule} from '@angular/forms';
import {AgGridModule} from 'ag-grid-angular';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import {ViewAttachmentFileComponent} from '../../A2-utils/grid-components/view-attachment-file/view-attachment-file.component';
import {GridComponentsModule} from '../../A2-utils/grid-components/grid-components.module';
import {DirectivesModule} from '../../../directives/directives.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AgGridModule.withComponents([ViewAttachmentFileComponent]),
    Trip2ThemeModule,
    GridComponentsModule,
    DirectivesModule
  ],
  declarations: [TripHistoryChangeComponent],
  exports: [
    TripHistoryChangeComponent
  ],
  providers: [
    ReservationService
  ]
})
export class TripHistoryChangeModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/trip-history-change/trip-history-change.module.ts